import React, { useEffect } from "react";
import { useGetRecentQuery } from "./Recentapislice";
import { useNavigate } from "react-router-dom";
import {
  IoIosStar,
  IoIosStarOutline,
  IoMdInformationCircleOutline,
} from "react-icons/io";
import { PiDotsThreeOutlineVerticalFill } from "react-icons/pi";
import useTitle from "../hooks/useTitle";
import { useToggleFavoriteMutation } from "./libraryApiSlice";
import { RxTimer } from "react-icons/rx";
import LoadingIndicator from "../components/BasicComponents/LoadingIndicator";
import { PiClockCounterClockwise } from "react-icons/pi";

export default function Recent() {
  useTitle("Vizta Recents");
  const navigate = useNavigate();

  const {
    data: recentPageData,
    isError: isRecentPageError,
    error: recentPageError,
    isLoading: isRecentPageLoading,
    refetch,
  } = useGetRecentQuery();

  const handleOpenFolder = (id) => {
    // console.log("Open folder with id:", id);
  };
  const [
    toggleFavorite,
    {
      data: toggleFavoriteMessage,
      isError: isToggleFavoriteError,
      isSuccess: isToggleFavoriteSuccess,
      isLoading: isToggleFavoriteLoading,
      error: toggleFavoriteError,
    },
  ] = useToggleFavoriteMutation();

  const handleOpenWorkbook = (workbookId, sheetId) => {
    if (workbookId && sheetId) {
      navigate(`/dashboard?workbookid=${workbookId}&sheetid=${sheetId}`);
    } else {
      // console.log("selectedSheetId is null or undefined");
    }
  };
  const handleFavoriteToggle = (id, type) => {
    const request = {
      workbookOrFolderId: id,
      type: type,
    };
    toggleFavorite(request);
  };
  // console.log(recentPageData);
  useEffect(() => {
    if (!isToggleFavoriteLoading) {
      refetch();
    }
  }, [isToggleFavoriteLoading, refetch]);

  return (
    <section className="p-2 h-[94vh] min-h-[94vh]">
      <section className="flex gap-2 items-center font-medium w-full justify-start p-1">
        <RxTimer className="text-black" /> Recent
        {isRecentPageError && (
          <p className="text-red-800 shadow-2xl rounded-md px-1">
            Error: {recentPageError?.message || "Something went wrong"}.
          </p>
        )}
        {isToggleFavoriteError && (
          <span className="text-red-800 shadow-2xl rounded-md px-1">
            Error : {toggleFavoriteError} , Please try again later!
          </span>
        )}
        {isToggleFavoriteSuccess ? (
          <span className="text-green-800 shadow-2xl rounded-md px-1">
            {toggleFavoriteMessage["message"]}
          </span>
        ) : null}
      </section>
      <section className="flex gap-x-20 gap-y-20 flex-wrap h-[86vh] overflow-y-auto p-2">
        {isRecentPageLoading || isToggleFavoriteLoading ? (
          <LoadingIndicator />
        ) : recentPageData && recentPageData.length ? (
          recentPageData.map((item, index) => (
            <section
              key={index}
              className="w-[228px] h-[150px] bg-white rounded hover:shadow-xl cursor-pointer"
            >
              {item !== null && item?.type === "folder" ? (
                <img
                  className="w-full h-full object-contain"
                  src="/graph_img/file.png"
                  alt="Folder"
                  onClick={() => handleOpenFolder(item._id)}
                />
              ) : (
                <img
                  className="w-full h-full object-contain"
                  src={item?.icon || "/placeholder.png"}
                  alt="File"
                  onClick={() =>
                    handleOpenWorkbook(item._id, item.selectedSheetId)
                  }
                />
              )}
              <div className="text-[14px] flex justify-between items-center pl-2">
                <p className="truncate">{item !== null && item?.name}</p>
                <section className="flex gap-3">
                  {item !== null && item.favourite ? (
                    <IoIosStar
                      onClick={() => handleFavoriteToggle(item._id, item.type)}
                    />
                  ) : (
                    <IoIosStarOutline
                      onClick={() => handleFavoriteToggle(item._id, item.type)}
                    />
                  )}
                  <IoMdInformationCircleOutline />
                  <PiDotsThreeOutlineVerticalFill />
                </section>
              </div>
            </section>
          ))
        ) : (
          <div className="flex items-center justify-center h-screen ml-[40%] ">
            <div className="flex flex-col items-center">
              <PiClockCounterClockwise className="text-9xl" />
              <h1 className="text-2xl font-medium text-gray-700 mt-4">
                You don’t have any Recent's.
              </h1>
              <p className="text-gray-500 mt-2">
                Check here to see content you have recently visited.
              </p>
            </div>
          </div>
        )}
      </section>
    </section>
  );
}
